<script setup>
import { RouterView } from 'vue-router'
</script>

<template>
  <div class="authentication-bg position-relative min-vh-100">
    <div class="account-pages pt-2 pt-sm-5 pb-4 pb-sm-5 position-relative">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-xxl-6 col-lg-8">
            <div class="card">
              <div class="card-body p-4">
                <RouterView />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
